module.exports = __webpack_public_path__ + "img/marker-black.1f41e908.svg";